document.addEventListener("DOMContentLoaded", function () {
  let nextPageUrl = document.querySelector("#pagination a[rel='next']")?.href;
  let isLoading = false;

  async function loadNextPage() {
    if (!nextPageUrl || isLoading) return;
    
    isLoading = true;
    const spinner = document.getElementById("load-more-spinner");
    if (spinner) spinner.style.display = "block";

    try {
      const response = await fetch(nextPageUrl);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, "text/html");
      
      const newCollection = html.querySelector("#Collection");
      const newItems = newCollection?.querySelectorAll(".grid--view-items .grid__item");
      const currentGrid = document.querySelector(".grid--view-items");
      
      if (newItems && currentGrid) {
        newItems.forEach(item => currentGrid.appendChild(item));
      }

      // Neue nächste Seite finden
      const nextLink = html.querySelector("link[rel='next']");
      nextPageUrl = nextLink ? nextLink.href : null;

      // Wenn es keine weitere Seite gibt → Trigger und Observer entfernen
      if (!nextPageUrl) {
        console.log("🚀 Trigger erreicht: keine weitere Seite");
        if (observer && trigger) {
          observer.unobserve(trigger);
        }
        if (trigger) {
          trigger.style.display = "none";
        }
        const crossSell = document.getElementById("cross-selling-container");
        if (crossSell) {
          crossSell.style.setProperty("display", "block", "important");
        }
      }
    } catch (error) {
      console.error("Fehler beim Laden weiterer Produkte:", error);
    }

    if (spinner) spinner.style.display = "none";
    isLoading = false;
  }

  // Cross-Selling auch anzeigen, wenn nur eine Seite verfügbar
  if (!document.querySelector("a[rel='next']")) {
  const crossSell = document.getElementById("cross-selling-container");
  if (crossSell) {
    crossSell.style.display = "block";
    console.log("✅ Cross-Sell sofort sichtbar – nur eine Seite vorhanden");
  }
}

  // Intersection Observer Setup
  const trigger = document.getElementById("load-trigger");
  let observer = null; // Variable außerhalb definieren

  if (trigger) {
    observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && nextPageUrl && !isLoading) {
        loadNextPage();
      }
    });
    observer.observe(trigger);
  }
});